import React, { useState } from "react";
import { motion } from "framer-motion";

const CATEGORIES = [
  "Residential",
  "Commercial",
  "Hospitality",
  "Industrial",
  "Hospital",
  "Automobile",
  "School & Institution",
  "Bungalow",
];

export default function AdminProjectForm() {
  const [form, setForm] = useState({
    name: "",
    category: CATEGORIES[0],
    services: "",
    location: "",
    description: "",
  });
  const [imageFile, setImageFile] = useState(null);
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleFileChange = (e) => {
    setImageFile(e.target.files[0] || null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Saving...");

    try {
      const fd = new FormData();
      fd.append("name", form.name);
      fd.append("category", form.category);
      fd.append("services", form.services);
      fd.append("location", form.location);
      // area removed
      fd.append("description", form.description);
      if (imageFile) {
        fd.append("image", imageFile);
      }

      const res = await fetch(
        '/api/create_project.php',
        {
          method: "POST",
          body: fd,
        }
      );

      const data = await res.json();

      if (!data.success) {
        throw new Error(data.error || "Failed to save");
      }

      setStatus("Saved successfully (ID: " + data.projectId + ")");
      // clear form
      setForm({
        name: "",
        category: CATEGORIES[0],
        services: "",
        description: "",
      });
      setImageFile(null);
      e.target.reset();
    } catch (err) {
      console.error(err);
      setStatus("Error: " + err.message);
    }
  };

  return (
    <div className="min-h-screen flex items-start justify-center bg-black py-10 px-4" style={{ marginTop: "90px" }}>
      <motion.form
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, type: "spring", bounce: 0.3 }}
        onSubmit={handleSubmit}
        className="w-full max-w-xl bg-black shadow-lg rounded-2xl p-8 space-y-4 border border-gray-600"
        encType="multipart/form-data"
      >
        <h2 className="text-2xl font-bold mb-4 text-white">Add Project</h2>

        <div>
          <label className="block text-sm font-medium mb-1 text-white">Project Name</label>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2 text-sm bg-black text-white border-gray-700 placeholder-gray-400"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-white">Location</label>
          <input
            name="location"
            value={form.location}
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2 text-sm bg-black text-white border-gray-700 placeholder-gray-400"
            placeholder="Enter project location"
            required
          />
        </div>


        <div>
          <label className="block text-sm font-medium mb-1 text-white">Category</label>
          <select
            name="category"
            value={form.category}
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2 text-sm bg-black text-white border-gray-700"
          >
            {CATEGORIES.map((c) => (
              <option key={c} value={c} className="bg-black text-white">
                {c}
              </option>
            ))}
          </select>
        </div>





        <div>
          <label className="block text-sm font-medium mb-1 text-white">Services</label>
          <textarea
            name="services"
            value={form.services}
            onChange={handleChange}
            rows={4}
            className="w-full border rounded-lg px-3 py-2 text-sm bg-black text-white border-gray-700 placeholder-gray-400"
            placeholder="Enter services provided"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 text-white">
            Description / Details
          </label>
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
            rows={4}
            className="w-full border rounded-lg px-3 py-2 text-sm bg-black text-white border-gray-700 placeholder-gray-400"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 text-white">
            Project Image
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="block w-full text-sm text-white bg-black border-gray-700"
          />
        </div>

        <button
          type="submit"
          className="w-full py-2 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
        >
          Save Project
        </button>

        {status && (
          <p className="text-xs text-white mt-2 whitespace-pre-line">
            {status}
          </p>
        )}
      </motion.form>
    </div>
  );
}
